
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFC511","d":"M22.25 26a2.25 2.25 0 002.25-2.25V7.25A2.25 2.25 0 0022.25 5H20V2.375A.376.376 0 0019.625 2h-.75a.376.376 0 00-.375.375V5h-9V2.375A.376.376 0 009.125 2h-.75A.376.376 0 008 2.375V5H5.75A2.25 2.25 0 003.5 7.25v16.5A2.25 2.25 0 005.75 26h16.5zM23 9.5H5V7.25c0-.412.338-.75.75-.75h16.5c.412 0 .75.338.75.75V9.5zm-.75 15H5.75a.752.752 0 01-.75-.75V11h18v12.75c0 .412-.338.75-.75.75zm-9-4.5c.412 0 .75-.338.75-.75v-4.5a.752.752 0 00-.75-.75h-4.5a.752.752 0 00-.75.75v4.5c0 .412.337.75.75.75h4.5zm-.75-1.5h-3v-3h3v3z"}})])
          )
        }
      }
    